module.exports = __webpack_public_path__ + "img/pricing-hero.f7b247da.jpg";